<div class="app-page-title">
  <div class="page-title-wrapper">
    <div class="page-title-heading">
      <div class="page-title-icon">
        <i class="pe-7s-box2 icon-gradient bg-mean-fruit"> </i>
      </div>
      <div>
        {{ "data.trailer" | translate }}
        <div class="page-title-subheading">
          {{ "data.trailer_detail" | translate }}
        </div>
      </div>
    </div>
    <div class="page-title-actions">
      <div class="d-inline-block dropdown">
        <button
          class="mr-2 btn-icon btn-icon-only btn btn-outline-info"
          (click)="exportData()"
        >
          <i class="fa fa-download fa-w-20 mr-3"></i>
          <span>Extraire les données</span>
        </button>
      </div>

      <div class="d-inline-block dropdown">
        <button
          (click)="generatePdf()"
          class="mr-2 btn-icon btn-icon-only btn btn-outline-primary"
        >
          <i class="fa fa-file-pdf fa-w-20 mr-3"> </i>
          <span>Generer PDF</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isLoading; else elseAllCmds">
  <div class="row">
    <div class="col-md-12">
      <div class="main-card mb-3 card">
        <div class="card-body text-center">
          <div class="spinner-container blue-spinner">
            <mat-progress-spinner
              mode="indeterminate"
              [diameter]="40"
              [strokeWidth]="5"
            ></mat-progress-spinner>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #elseAllCmds>
  <div #pdfContent class="pdf-content">
    <div class="row">
      <div class="col-md-12">
        <div class="main-card mb-3 card">
          <div class="card-header">{{ "data.trailer" | translate }}</div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <b>{{ "data.trailer_number" | translate }}: </b
                >{{ trailer?.remorqueId }}<br />
                <b>{{ "data.transporter" | translate }}: </b
                >{{ trailer.transportor?.nameSociety }}<br />
                <b>{{ "data.Transport_type" | translate }}: </b
                >{{ trailer?.transportorType }}<br />
                <b>{{ "data.plateform" | translate }}: </b
                >{{ trailer?.plateform }}<br /><br />

                <b>{{ "data.creation_date" | translate }}: </b
                >{{ trailer?.creation_date | date: "d MMM y" }}<br />
                <b>{{ "data.volume" | translate }}: </b
                >{{
                  (trailer?.totalVolume | number: "1.2-2")?.replace(",", "")
                }}
                m³<br />
                <b>{{ "data.total_weight" | translate }}: </b
                >{{
                  (trailer?.totalWeight | number: "1.1-1")?.replace(",", "")
                }}
                Kg<br />
                <!-- <b>{{ "data.total" | translate }}: </b
              >{{
                (trailer?.totalCost | number: "0.1-3")?.replace(",", "")
              }}
              €<br /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="main-card mb-3 card">
          <div class="tab-content" id="tab-content">
            <div class="main-card mb-12 card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-12">
                    <div class="table-responsive">
                      <table
                        class="align-middle mb-0 table table-borderless table-striped table-hover"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">#</th>
                            <th>{{ "data.label" | translate }}</th>
                            <th>{{ "data.value" | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            *ngFor="
                              let item of trailer?.invoiceTaxes;
                              let index = index
                            "
                          >
                            <td class="text-center text-muted">
                              #{{ index + 1 }}
                            </td>
                            <td>
                              {{ item.label }}
                            </td>
                            <td>{{ item.value | number: "1.2-2" }} €</td>
                          </tr>

                          <tr>
                            <td class="text-center text-muted">
                              #{{ trailer?.invoiceTaxes?.length + 1 }}
                            </td>
                            <td>
                              {{ "data.total_removal_cost" | translate }}
                            </td>
                            <td>
                              {{
                                (trailer?.totalCost | number: "0.1-3")?.replace(
                                  ",",
                                  ""
                                )
                              }}
                              €
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div class="clearfix"></div>

                <div class="row mt-5">
                  <div class="col-lg-8">
                    <!-- <div class="section-title">{{ "data.delivery_method" | translate }}</div>
      <p class="section-lead">
        {{ "data.destination" | translate }}
        <br />→ {{ cmd.destination_cmd }}
      </p> -->
                  </div>
                  <div class="col-lg-4 text-right">
                    <div class="invoice-detail-item">
                      <!-- <div class="invoice-detail-value">
                        {{ "data.total_removal_cost" | translate }}:
                        {{
                          (trailer?.totalCost | number: "0.1-3")?.replace(
                            ",",
                            ""
                          )
                        }}
                        €
                      </div> -->
                      <div class="invoice-detail-value">
                        {{ "data.total_purchase_order" | translate }}:
                        {{
                          (
                            getTotalPurchaseOrder(
                              trailer?.invoiceTaxes,
                              trailer?.totalCost
                            ) | number: "0.1-3"
                          )?.replace(",", "")
                        }}
                        €
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="main-card mb-3 card">
          <div class="card-body">
            <div class="table-responsive">
              <table
                class="align-middle mb-0 table table-borderless table-striped table-hover"
              >
                <thead>
                  <tr>
                    <th class="text-center">#</th>
                    <th>{{ "data.provider" | translate }}</th>
                    <th>{{ "data.reference" | translate }}</th>
                    <th>{{ "data.creation_date" | translate }}</th>
                    <th class="text-center">
                      {{ "data.products" | translate }}<br />
                      {{ "data.quantity_product_name" | translate }}
                    </th>
                    <th class="text-center">
                      {{ "data.volume" | translate }}<br />(m³)
                    </th>
                    <th class="text-center">
                      {{ "data.total_weight" | translate }}<br />(Kg)
                    </th>
                    <th class="text-center">
                      {{ "data.total" | translate }}<br />(€)
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let cmd of trailer?.commands; let index = index">
                    <td class="text-center text-muted">#{{ index + 1 }}</td>
                    <td>
                      <div class="widget-content p-0">
                        <div class="widget-content-wrapper">
                          <div class="widget-content-left mr-3">
                            <div class="widget-content-left">
                              <ngx-avatar
                                class="rounded-circle"
                                name="{{ cmd?.client_cmd?.prenom_client }}
                                                {{
                                  cmd?.client_cmd?.nom_client
                                }}"
                              >
                              </ngx-avatar>
                            </div>
                          </div>
                          <div class="widget-content-left flex2">
                            <div class="widget-heading">
                              {{ cmd?.client_cmd?.providerName }}
                            </div>
                            <div class="widget-subheading opacity-7">
                              {{
                                cmd?.client_cmd?.shippingAdress?.label_target
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td>{{ cmd?.ref_facture_cmd }}</td>
                    <td>
                      {{ cmd?.date_creation_cmd | date: "d MMM y" }}<br />
                      <b>{{ cmd?.date_creation_cmd | date: "HH:mm" }}</b>
                    </td>
                    <td>
                      <ul
                        class="rm-list-borders rm-list-borders-scroll list-group list-group-flush"
                        *ngIf="cmd?.totalBoxes > 0"
                      >
                        <li class="list-group-item">
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div
                                class="widget-content-left mr-3 widget-pallet"
                              >
                                <img
                                  width="100%"
                                  src="https://assets.marketbey.tn/WTM/products/box.png"
                                  alt=""
                                />
                              </div>
                              <div class="widget-content-right">
                                <div class="font-size-lg text-muted">
                                  <span>
                                    {{
                                      cmd?.totalBoxes -
                                        (cmd?.etat_cmd ==
                                          "partially_received" &&
                                        cmd?.totalBoxesReceived
                                          ? cmd?.totalBoxesReceived
                                          : 0)
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <ul
                        class="rm-list-borders rm-list-borders-scroll list-group list-group-flush"
                        *ngIf="cmd?.totalPallets > 0"
                      >
                        <li class="list-group-item">
                          <div class="widget-content p-0">
                            <div class="widget-content-wrapper">
                              <div
                                class="widget-content-left mr-3 widget-pallet"
                              >
                                <img
                                  width="100%"
                                  src="https://assets.marketbey.tn/WTM/products/pallet.png"
                                  alt=""
                                />
                              </div>
                              <div class="widget-content-right">
                                <div class="font-size-lg text-muted">
                                  <span>
                                    {{
                                      cmd?.totalPallets -
                                        (cmd?.etat_cmd ==
                                          "partially_received" &&
                                        cmd?.totalPalletsReceived
                                          ? cmd?.totalPalletsReceived
                                          : 0)
                                    }}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </td>
                    <td class="text-center">
                      {{
                        cmd?.totalPalletVolume -
                          (cmd?.etat_cmd == "partially_received" &&
                          cmd?.totalPalletVolumeReceived
                            ? cmd?.totalPalletVolumeReceived
                            : 0) | number: "0.1"
                      }}
                    </td>
                    <td class="text-center">
                      <div *ngIf="cmd?.etat_cmd !== 'partially_received'">
                        {{ cmd?.totalPoids | number: "0.1" }}
                      </div>
                    </td>
                    <td class="text-center">
                      {{ cmd?.total_ca_cmd | number: "0.3" }} EUR
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
